// 1. The SearchInputAlgolia component is a React search input integrated with Algolia using the react-instantsearch-hooks-web library.
// 2. It initializes the search with InstantSearch and displays a search box via the AlgoliaSearchBox component.
// 3. When the input is focused, it shows a dropdown of search suggestions using the Hits component, with each suggestion rendered by AlgoliaSearchSuggestion.
// 4. The component manages the dropdown's visibility using useState to track input focus.
// 5. The search suggestions are scrollable within a limited height and styled with a border and shadow for better presentation.

export type ShoeSearch = {
  searchTerm?: string;
  suggestedTerm?: string;
  Brands?: string;
  BrandsUrl?: string;
};

type SearchConfiguration = {
  searchConfiguration: ShoeSearch[];
};
import React, { useEffect, useState } from 'react';
import { InstantSearch, Hits, useInstantSearch } from 'react-instantsearch-hooks-web';
import { searchClientWithEmptyCheck } from 'algolia/searchClientWithEmptyCheck';
import AlgoliaSearchBox from './searchBox';
import AlgoliaSearchSuggestion from './algoliaSearchSuggestion';
import { Hit as AlgoliaHit, BaseHit } from 'instantsearch.js';
import useLocale from 'helpers/hooks/useLocale';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import results from 'public/locales/en/product.json';
import { VariantsAlgolia } from '../Algolia-search-Page/Hit';

type ExtendedHit = AlgoliaHit<BaseHit>;
interface ProductName {
  [locale: string]: string;
}

interface SearchInputAlgolia {
  searchConfiguration: SearchConfiguration | any;
  searchPage?: any;
}
const SearchInputAlgolia = ({ searchConfiguration, searchPage }: SearchInputAlgolia) => {
  const [isFocused, setIsFocused] = useState(false);
  const { locale, getCurrency } = useLocale();
  let mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_US;

  // const hostName = typeof window !== 'undefined' ? window.location.hostname : '';
  // if (hostName?.includes('.eu') || hostName?.includes('-eu')) {
  if (getCurrency() !== 'GBP') {
    mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_DE;
  } else if (locale === 'en' || locale === 'en_GB') {
    mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_US;
  } else {
    mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_DE;
  }
  // const indexName: string | undefined = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX_DE;
  const [queryString, setQueryString] = useState<string>();
  const [hit, setHit] = useState<ExtendedHit>();
  const router = useRouter();
  const [submited, setsubmited] = useState<boolean>(false);

  const handleSuggestionClick = () => {
    setIsFocused(true);
  };

  // const convertProductNameToUrl = (input: string) => {
  //   const urlformat = `${input?.toLowerCase().replace(/\s+/g, '-')}`;
  //   const url = urlformat?.endsWith('-') ? urlformat : `${urlformat}-`;
  //   return url.replace(/,/g, '');
  // };
  const matching = (hit?.variants as any)?.some((i: VariantsAlgolia) => i.sku === queryString) ? hit : null;

  const suggestions = searchConfiguration?.searchConfiguration?.filter(
    (i: ShoeSearch) => i?.searchTerm && queryString?.toLowerCase().includes(i.searchTerm.toLowerCase()),
  );
  const RedirectFromAlgolia = ({ inputValue, submited, hit, matching }: any) => {
    const { results } = useInstantSearch();
    const router = useRouter();
    const [hasRedirected, setHasRedirected] = useState(false);

    const convertProductNameToUrl = (input: string) => {
      const urlformat = `${input?.toLowerCase().replace(/\s+/g, '-')}`;
      const url = urlformat?.endsWith('-') ? urlformat : `${urlformat}-`;
      return url.replace(/,/g, '');
    };

    useEffect(() => {
      if (!submited || hasRedirected || !results) return;

      let redirectUrl = (results?.renderingContent as any)?.redirect?.url;
      if (Array.isArray(redirectUrl)) {
        redirectUrl = redirectUrl[0];
      }
      if (redirectUrl) {
        setHasRedirected(true);
        router.push(redirectUrl);
        return;
      } else if (
        inputValue === '9988004001005' ||
        inputValue === '9988003001006' ||
        inputValue?.toLowerCase()?.includes('voucher') ||
        inputValue?.toLowerCase()?.includes('gift')
      ) {
        router.push('/services/giftcards-evouchers.html');
      } else {
        if (queryString) {
          window.location.href = `/search/${encodeURIComponent(queryString)}`;
        }
      }

      // if (
      //     (hit?.name as ProductName)?.[locale.replace('_', '-')].replace(/\s+/g, '').toLowerCase() ===
      //     (queryString as any)?.replace(/\s+/g, '').toLowerCase() &&
      //     submited
      // ) {
      //     router.push(
      //         '/' +
      //         convertProductNameToUrl((hit?.name as any)?.[locale?.replace('_', '-')]) +
      //         (hit?.slug as any)?.[locale.replace('_', '-')] +
      //         '.html',
      //     );
      // }

      // } else if (/^\d+$/.test(queryString as any)) {
      //     if (matching) {
      //         router.push(
      //             convertProductNameToUrl((matching?.name as any)?.[locale?.replace('_', '-')]) +
      //             (matching?.slug as any)?.[locale.replace('_', '-')] +
      //             '.html',
      //         );
      //     }
      // }

      // if (queryString) {
      //     //window.location.href = `/search/${encodeURIComponent(queryString)}`;
      // }
    }, [submited, results, hit, matching, inputValue, locale, hasRedirected, router, queryString]);

    return null;
  };

  return (
    <div className="relative flex flex-col items-center">
      <InstantSearch searchClient={searchClientWithEmptyCheck} indexName={mainIndex}>
        <AlgoliaSearchBox
          isFocused={isFocused}
          onFocusChange={setIsFocused}
          setsubmited={setsubmited}
          setQueryString={setQueryString}
          handleSuggestionClick={handleSuggestionClick}
          hitMatch={matching}
          isSearchPage={searchPage}
        />
        <RedirectFromAlgolia inputValue={queryString} submited={submited} hit={hit} matching={matching} />
        {!searchPage && (
          <>
            {queryString && isFocused && (
              <div
                className="absolute top-[50px] z-10 max-h-[83vh] w-[310px] overflow-y-auto rounded-lg border border-gray-300 bg-white shadow-lg"
                onMouseDown={(e) => e.preventDefault()}
              >
                {queryString === '9988004001005' ||
                queryString === '9988003001006' ||
                queryString?.toLowerCase()?.includes('voucher') ||
                queryString?.toLowerCase()?.includes('gift') ? (
                  <>
                    <div>
                      <Link href={'/services/giftcards-evouchers.html'}>
                        <div className="flex cursor-pointer items-center justify-between gap-x-2 border-b px-10 py-15 transition-colors duration-200 hover:bg-gray-100">
                          <div className="flex items-center">
                            <div className="max-w-[50px] pr-10">
                              <img
                                src={'https://cdn.media.amplience.net/i/americangolf/gift--card--desktop'}
                                alt={'gift voucher'}
                                className="h-full w-full rounded-lg object-cover shadow-sm"
                              />
                            </div>
                            <p className="w-[140px] text-sm font-medium text-gray-900">{'Gift Voucher'}</p>
                          </div>
                          {/* <div className="flex items-center">
                            {productPrice && (
                              <p className="pr-3 text-sm font-semibold">
                                {currency === 'GBP' ? '£' : '€'}
                                {(productPrice / 100)?.toFixed(2)}
                              </p>
                            )}
                            <span className="text-[#127e57]">
                              {' '}
                              <ChevronRightIcon
                                className="mt-2 h-15 w-18 font-bold text-[#127e57]"
                                stroke="currentColor"
                                strokeWidth="3"
                                fill="none"
                              />
                            </span>
                          </div> */}
                        </div>
                      </Link>
                    </div>
                  </>
                ) : (
                  <Hits<ExtendedHit>
                    hitComponent={({ hit }) => {
                      setHit(hit);
                      return (
                        <div>
                          <AlgoliaSearchSuggestion
                            hits={{ hit }}
                            onSuggestionClick={handleSuggestionClick}
                            matchingProduct={matching}
                            searchConfiguration={searchConfiguration}
                            queryString={queryString}
                            isSearchPage={searchPage}
                          />
                        </div>
                      );
                    }}
                  />
                )}
                <div className="m-20">
                  {suggestions?.map((i: ShoeSearch, index: number) => (
                    <div key={index}>
                      <Link href={`/search/${i?.suggestedTerm}`}>
                        <p className="mt-20">{i?.suggestedTerm}</p>
                      </Link>
                      <Link href={`/${i?.BrandsUrl || ''}`}>
                        <p className="mt-20">{i?.Brands}</p>
                      </Link>
                    </div>
                  ))}
                </div>
                <div className="flex justify-center px-5 py-10">
                  <Link href={`/search/${queryString}`}>
                    <div className="cursor-pointer text-sm underline">{results?.algoliaResults}</div>
                  </Link>
                </div>
              </div>
            )}
          </>
        )}
      </InstantSearch>
    </div>
  );
};

export default SearchInputAlgolia;
